import { useEffect, useState } from "react";
import { API } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { Stat, PageHeader, Loading, StatusBadge, Table, Empty } from "../../components/common";

export default function AdminRevenue() {
  const [data, setData] = useState(null);
  useEffect(() => { API.get("/admin/revenue").then((r) => setData(r.data)); }, []);
  if (!data) return <Loading label="Loading revenue" />;

  return (
    <div data-testid="admin-revenue">
      <PageHeader title="Revenue Dashboard" sub="Subscription MRR, plan mix, and Tax Rescue services — fully separate from client tax money." />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat label="Monthly Recurring Revenue" cents={data.mrr_cents} tone="green" testid="rev-mrr" />
        <Stat label="Annual Recurring Revenue" cents={data.arr_cents} tone="navy" testid="rev-arr" />
        <Stat label="Active Subscriptions" value={data.active_subscriptions} tone="blue" testid="rev-active-subs" />
        <Stat label="Tax Rescue Revenue" cents={data.rescue_revenue_cents} tone="gold" testid="rev-rescue" />
      </div>

      <div className="mt-6 grid gap-6 lg:grid-cols-3">
        <div className="card-gov p-5">
          <h3 className="mb-3 font-bold text-navy">Revenue by Plan</h3>
          {Object.keys(data.by_plan).length === 0 ? <p className="text-sm text-slate-500">No active subscriptions yet.</p> : (
            <ul className="space-y-2">
              {Object.entries(data.by_plan).map(([slug, v]) => (
                <li key={slug} className="flex items-center justify-between rounded border border-slate-200 px-3 py-2" data-testid={`rev-plan-${slug}`}>
                  <span className="font-semibold capitalize text-slate-700">{slug} <span className="text-xs text-slate-400">({v.count})</span></span>
                  <span className="money font-bold text-navy">${(v.mrr_cents / 100).toLocaleString()}/mo</span>
                </li>
              ))}
            </ul>
          )}
          <div className="mt-4 grid grid-cols-2 gap-2 text-center text-sm">
            <div className="rounded bg-slate-50 py-2"><div className="money font-bold text-slate-700">{data.cancelled}</div><div className="text-[10px] uppercase text-slate-400">Cancelled</div></div>
            <div className="rounded bg-slate-50 py-2"><div className="money font-bold text-rose-600">{data.past_due_subscriptions}</div><div className="text-[10px] uppercase text-slate-400">Past Due</div></div>
          </div>
        </div>

        <div className="lg:col-span-2">
          <h3 className="mb-3 font-bold text-navy">Billing Transactions</h3>
          {data.transactions.length === 0 ? <Empty title="No Stripe transactions yet" msg="Checkout sessions, subscription payments, and rescue fees appear here." /> : (
            <Table headers={["Date", "Lookup", "Amount", "Payment", "Status"]} testid="rev-transactions">
              {data.transactions.map((t) => (
                <tr key={t.id} className="border-b border-slate-100">
                  <td className="px-4 py-2.5 text-xs text-slate-500">{fmtDate(t.created_at)}</td>
                  <td className="px-4 py-2.5 font-mono text-xs">{t.lookup_key}</td>
                  <td className="px-4 py-2.5 money font-semibold">${(t.amount_cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2 })}</td>
                  <td className="px-4 py-2.5"><StatusBadge status={t.payment_status === "paid" ? "PAID" : t.payment_status} /></td>
                  <td className="px-4 py-2.5"><StatusBadge status={t.status} /></td>
                </tr>
              ))}
            </Table>
          )}
        </div>
      </div>
    </div>
  );
}
